import React, { useState } from 'react';
import {
    Grid,
    Paper,
    TextField,
    Button,
    Snackbar,
} from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import MuiAlert from '@mui/material/Alert';
import makeStyles from '@mui/styles/makeStyles';
import { BASE_URL_API } from '../Const';

const useStyles = makeStyles((theme) => ({
    paperStyle: {
        padding: 40,
        height: '70vh',
        width: 380,
        margin: '20px auto',
        backgroundColor: '#ffffff',
        borderRadius: 12,
    },
    logo: {
        width: 96,
        height: 96,
        objectFit: 'contain',
        marginBottom: 8,
    },
    formControl: {
        direction: 'rtl',
        textAlign: 'right',
        marginTop: theme.spacing(2),
    },
    labelRoot: {
        right: 0,
        left: 'auto',
        transformOrigin: 'top right',
        direction: 'rtl',
    },
    labelShrink: {
        right: 0,
        left: 'auto',
        transformOrigin: 'top right',
    },
    input: {
        textAlign: 'right',
        paddingRight: 14,
        paddingLeft: '0 !important',
    },
    btnStyle: {
        marginTop: 24,
        backgroundColor: '#FF1744',
        color: 'white',
        padding: '12px 0',
        fontWeight: 'bold',
        fontSize: 16,
    },
}));
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const OtpComponent = () => {
    const classes = useStyles();

    const [phone, setPhone] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [message, setMessage] = useState('');

    const handlePhoneChange = (e) => {
        const input = e.target.value;
        if (/^\d{0,11}$/.test(input)) {
            setPhone(input);
        }
    };

    const handleSubmit = () => {
        const phoneRegex = /^09\d{9}$/;

        if (!phoneRegex.test(phone)) {
            setMessage('فرمت شماره تلفن معتبر نیست. باید با 09 شروع شده و 11 رقم باشد.');
            setSnackbarOpen(true);
            return;
        }

        fetch(`${BASE_URL_API}lookup`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                phone,
                role: 'user',
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.code === '200') {
                    localStorage.setItem(
                        'pwa_temp_user_token',
                        result.data.temporary_token,
                    );
                    window.location.assign('login');
                } else {
                    setMessage(result.message);
                    setSnackbarOpen(true);
                }
            });
    };

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{ height: '100vh', backgroundColor: '#f7f7f7' }}
        >
            <Paper elevation={10} className={classes.paperStyle}>
                <Grid align="center">
                    <img
                        alt="logo"
                        className={classes.logo}
                        src="/hamekara-logo.png"
                    />
                    <ListItemText
                        primary="ورود به همه کارا"
                        style={{ fontWeight: 'bold', fontSize: 20 }}
                    />
                </Grid>

                <TextField
                    fullWidth
                    required
                    value={phone}
                    onChange={handlePhoneChange}
                    id="phone"
                    label="شماره تلفن"
                    placeholder="09123456789"
                    margin="normal"
                    className={classes.formControl}
                    InputLabelProps={{
                        classes: {
                            root: classes.labelRoot,
                            shrink: classes.labelShrink,
                        },
                        shrink: true,
                    }}
                    InputProps={{
                        classes: {
                            input: classes.input,
                        },
                    }}
                />

                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    fullWidth
                    className={classes.btnStyle}
                >
                    ارسال کد
                </Button>
            </Paper>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity="error"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </Grid>
    );
};

export default OtpComponent;
